const getCartItemsCount = (cart, order) => {
  if (cart?.cartItems) return cart.cartItems.length;
  if (order?.orderItems) return order.orderItems.length;
  return 0;
};

export { getCartItemsCount };
